import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, CardContent, Grid, CardMedia } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import clock from '../../assets/clock.png';

const styles = (theme) => ({
  name: {
    fontFamily: "'Lato', sans-serif",
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '17px',
  },
  description: {
    fontFamily: "'Lato', sans-serif",
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    lineHeight: '175%',
    color: '#555555',
  },
});

class NoCampaign extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Card
        style={{
          cursor: 'pointer',
          margin: 20,
          borderRadius: 5,
        }}
      >
        <CardContent style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Grid container justify="center" alignItems="center">
            <Grid item md={12}>
              <Grid className={`${classes.description}`} justify="center" alignItems="center">
                <CardMedia>
                  <span className={`${classes.name}`}>hold down</span>, we have some exciting
                  campaigns coming up
                </CardMedia>
                <img
                  src={clock}
                  alt={'waiting'}
                  style={{
                    width: '100px',
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <hr />
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withRouter(withStyles(styles)(NoCampaign));
